goog.provide("shadow.js.shim.module$src$svg$editor$editing$copy_svg$default");
shadow.js.shim.module$src$svg$editor$editing$copy_svg$default = shadow.js.shim.module$src$svg$editor$editing$copy_svg.default;
